import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../Layout/Theme/ThemeContext";
import Loader from "../Setup/views/Loader";
import useFormSubmission from '../Auth/Controller/AuthController';
import ModuleService from '../Setup/controller/ModuleController/ModuleController';
import { SidebarContext } from '../Layout/SidebarContext';
import ReportView from "../Dashboard/View/ReportView";
import BASE_URL from "../../config/config";
import { useTranslation } from 'react-i18next';
import { handleChange, handleSubmit as handleUserSubmit } from "../Setup/controller/UserController/CreateUserProfileController";
import UserService from "../Setup/controller/UserController/UserController";
import Swal from 'sweetalert2';
import Draggable from 'react-draggable';
import FormService from "../Setup/controller/FormController/FormController";
import ClientLanguages from "../Setup/controller/LanguageController/LanguageController";
import HelpLinkService from "../SuperAdmin/Controller/Configuration/HelpLinkController";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import MultiSelectDropdown from "./MultiSelectDropdown";
import SunTextEditor from "./SunTextEditor";
import axios from "axios";
import HelpSite from "./HelpLink";
const MODULE_IDS = {
  Assets: 3,
  Parts: 4,
  Suppliers: 5,
  Quotations: 6,
  SalesOrders: 7,
  Purchasing: 8,
  Agreements: 9,
  Jobs: 10,
  Contacts: 15,
  Opportunities: 18,
  Invoices: 22
};
// this set the default value of the properties used by the common component
Common.defaultProps = {
  showAddButton: 'none',
  showReportButton: 'none',
  showServiceJob: 'none',
  showSaleOrder: 'none',
  showPurchaseOnOrder: "none",
  showPurchaseDelivery: "none",
  showShipSaleOrder: "none",
  showDeleteButton: "none",
  showRenewButton: "none",
  showCreateOppotunity: "none",
  showCreateCustomer: "none",
  showShortFallParts: "none",
  showLeadSchedular: "none",
  showSynchronize: "none",
  showShippment: "none",
  showUnAllocate: "none",
  showClientButton: "none",
  showSerialButton: "none",
  showBatchButton: "none",
  showExportButton: "none",
  showEmailButton: "none",
  showInvoice: "none",
  showPartMovment: "none",
  showSendEmailing: "none",
  showEmailingList: "none",
  showResetEmailingList: "none",
  showUnAssignUser: "none",
  showPrintUser: "none",
  showAssignUser: "none",
  showInboxEmail: "none",
  showInvoiceButton: "none",
  showSyncInboxEmail: "none",
  showHelpSite: "none",
  showWriteOffButton: "none",
  showReinstateButton: "none",
  showPartDiscountButton: "none"

};

// this is the opening of Common component - The purpose of this component is to creat header and 
// all the relevant functionalities of the header in common place
function Common({ showAddButton, handleAddTask, showReportButton, handleReports,
  showServiceJob, handleServiceJob, showSaleOrder, handleSaleOrder,
  showPurchaseOnOrder, handlePurchaseOnOrder,
  showPurchaseDelivery, handlePurchaseOnOrderDelivery,
  showShipSaleOrder, handleShipSaleOrder,
  showDeleteButton, handleDeleteItem,
  showRenewButton, handleRenewAgreement, ModuleID, showCreateOppotunity, handleCreateOppotunity,
  showCreateCustomer, handleCreateCustomer, showShortFallParts, handleShortFallParts,
  showLeadSchedular, handleLeadSchedular, showSynchronize, handleSynchronize,
  showShippment, handleShippment, showUnAllocate, handleUnAllocate,
  showClientButton, handleCreateClientClick,
  showSerialButton, handleSerialTracking,
  showBatchButton, handleBatchManagement,
  showExportButton, handleExportExcel,
  showEmailButton, handleSendEmail,
  showInvoice, handleInvoice,
  showPartMovment, handlePartMovment,
  showSendEmailing, handleEmailing,
  showEmailingList, handleEmailingList,
  showResetEmailingList, handleReset,
  showUnAssignUser, handleUnAssignToUser,
  showPrintUser, handlePrintUser,
  isDisabled = false,
  showAssignUser, handleAssignToUser,
  assignmentTitle, IsAttachment,
  showInboxEmail, handleInboxEmail, ModuleName,
  showInvoiceButton, handleInvoiceCreate,
  showSyncInboxEmail, handleSyncInboxEmail,
  titleBar,
  HelpFormName, HelpModule, handleShippmentTitle,
  showWriteOffButton, handleWriteOff,
  showReinstateButton, handleReinstate,
  showPartDiscountButton, handlePartDiscount, RecordID
}) {

  const { theme, toggleTheme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const { updateSidebarModules } = useContext(SidebarContext);
  const RoleID = localStorage.getItem('RoleID');
  const CompanyID = localStorage.getItem('CompanyID');
  const HelpLink = localStorage.getItem('HelpLink');
  const IsAdminLogin = localStorage.getItem('IsAdminLogin');

  const multipleCompanies = localStorage.getItem('MultipleCompanies');
  const companies = JSON.parse(localStorage.getItem('Companies')) || [];
  const DisplayName = localStorage.getItem('DisplayName');

  let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

  const location = useLocation();
  const url = new URL(window.location.origin + location.pathname);
  const pathname = url.pathname;
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [assignedModules, setAssignedModules] = useState(new Set());
  const handleSubmit = useFormSubmission();
  const [errorMessage, setErrorMessage] = useState('');
  const [userNotification, setUserNotification] = useState('0');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState("User");
  const { t, i18n } = useTranslation();
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [userList, setUserList] = useState([]);

  const [isMfaModalOpen, setIsMfaModalOpen] = useState(false);
  const [qrCode, setQrCode] = useState(null);
  const [secretKey, setSecretKey] = useState('');
  const [mfaCode, setMfaCode] = useState('');
  const [message, setMessage] = useState('');

  const handleMfaSetupClick = async () => {
    try {
      const email = localStorage.getItem("UserName") || localStorage.getItem("Email");
      const response = await axios.post(`${BASE_URL}/Auth/generate-auth-secret`, { email });
      debugger;
      if (response.data.qr) {
        setQrCode(response.data.qr);
        setSecretKey(response.data.secret);
        setMessage(
          response.data.message ||
          "Scan this QR with Google or Microsoft Authenticator."
        );
        setIsMfaModalOpen(true);
      }
      else if (response.data.message === "Authenticator already enabled") {
        Swal.fire("Error", "Authenticator already enabled.", "error");
      }
      else {
        Swal.fire("Error", "Failed to generate QR code. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error generating MFA secret:", error);
      Swal.fire("Error", "Unable to generate MFA setup. Please try again.", "error");
    }
  };
  // Reset MFA
  const handleResetMfaClick = async () => {
    const email = localStorage.getItem("UserName") || localStorage.getItem("Email");
    const confirmReset = await Swal.fire({
      title: 'Are you sure?',
      text: "This will remove your MFA setup. You’ll have to reconfigure it later.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, reset it!',
      cancelButtonText: 'Cancel'
    });

    if (!confirmReset.isConfirmed) return;

    try {
      debugger;
      const res = await axios.post(`${BASE_URL}/Auth/reset-auth`, { email });
      debugger;
      if (res.data.success) {
        Swal.fire('Success', 'MFA has been reset successfully.', 'success');
      } else {
        Swal.fire('Error', res.data.message || 'Unable to reset MFA.', 'error');
      }
    } catch (error) {
      console.error('Error resetting MFA:', error);
      Swal.fire('Error', 'Server error. Try again.', 'error');
    }
  };

  // Verify MFA code entered by user
  const handleVerifyMfaCode = async () => {
    try {
      const email = localStorage.getItem("UserName") || localStorage.getItem("Email");
      const res = await fetch(`${BASE_URL}/Auth/verify-auth-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, token: mfaCode }),
      });
      const data = await res.json();

      if (data.success) {
        // setIsMfaVerified(true);
        Swal.fire("Success", "Multifactor Authentication setup completed successfully!", "success");
        setIsMfaModalOpen(false);
        // reset fields
        setQrCode(null);
        setSecretKey("");
        setMfaCode("");
        setMessage("");
      } else {
        Swal.fire("Invalid Code", "The verification code is incorrect.", "error");
      }
    } catch (error) {
      console.error("Error verifying MFA code:", error);
      Swal.fire("Error", "Verification failed. Try again.", "error");
    }
  };

  const [formData, setFormData] = useState({
    Email: '', DisplayName: '', UserPassword: '', ConfirmPassword: '', RoleID: "0", TeamID: "0",
    RateMethod: '1', ExchangePassword: '', Rate: '0.00', Cost: '0.00', AdditionalRate: '0.00', AdditionalCost: '0.00',
    WeekendRate: '0.00', WeekendCost: '0.00', ProfilePic: '', EmailFooter: '',
    AllowUser: '', EmailAppPassword: ""
  });
  // this is the useEffect hook
  useEffect(() => {
    fetchAssignedModules();
    fetchUsers();
    fetchAllUsers();
    fetchUserNotification();
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  const fetchAssignedModules = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const modules = await ModuleService.GetRoleModules(redirectCallback, "en", CompanyID);
      const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
      setAssignedModules(moduleSet);
    } catch (error) {
      console.error('Error fetching assigned modules:', error);
    }
  };
  const fetchUserNotification = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const modules = await UserService.GetUserNotification(redirectCallback);
      setUserNotification(modules);
    } catch (error) {
      console.error('Error fetching assigned modules:', error);
    }
  };
  const handleReportsClick = async () => {
    setIsModalOpen(true);
  }
  // this function is called with user called on return button in the header
  const handleLoginClick = async (username, password) => {
    setIsLoading(true);
    const formData = { UserName: username, Password: password };
    //localStorage.clear();
    try {


      const response = await handleSubmit(null, formData, fetchModules, setErrors, setErrorMessage);
      if (response.data.multipleCompanies === false) {

        localStorage.setItem('token', response.data.companies[0].token); // Access token
        localStorage.setItem('refreshToken', response.data.companies[0].refreshToken); // Refresh token
        localStorage.setItem('CompanyID', response.data.companies[0].HostCompanyID);
        localStorage.setItem('RoleID', response.data.companies[0].RolesID);
        localStorage.setItem('UserID', response.data.companies[0].UserID);
        localStorage.setItem('DisplayName', response.data.companies[0].DisplayName);
        localStorage.setItem('Email', response.data.companies[0].Email);
        localStorage.setItem('CompanyName', response.data.companies[0].CompanyName);
        localStorage.setItem('Address1', response.data.companies[0].Address1);
        localStorage.setItem('ContractPrefix', response.data.companies[0].ContractPrefix);
        localStorage.setItem('AllowedUsers', response.data.companies[0].AllowedUsers);
        const ModuleList = await ModuleService.GetAllModules(redirectCallback, "en");
        localStorage.setItem('ModuleList', JSON.stringify(ModuleList));
        const FormList = await FormService.GetAllForms(redirectCallback);
        localStorage.setItem('FormList', JSON.stringify(FormList));
        const clientLanguage = await ClientLanguages.GetClientLanguage(redirectCallback, response.data.companies[0].HostCompanyID);
        localStorage.setItem('ClientLanguages', JSON.stringify(clientLanguage));
        const HelpLink = await HelpLinkService.GetAllHelpLinks(redirectCallback);
        if (HelpLink && HelpLink[0]) {
          localStorage.setItem('HelpLink', HelpLink[0].HelpLink);
        }
        localStorage.setItem('IsAdminLogin', "0");
        localStorage.setItem('MultipleCompanies', "1");
        fetchModules();
        navigate('/Dashboard');
      }



      // once user is logged then fetchModule should be called
      fetchModules();
    } catch (error) {
      setErrorMessage('Login failed. Please try again.');
      setIsLoading(false);
    }
  };
  const handleProfileClick = async () => {

    setIsProfileModalOpen(true);

  };
  const userOptions = userList.map(user => ({
    value: user.UserID,
    label: user.DisplayName,
  }));
  const handleUserNameChange = async (selectedValues) => {
    setSelectedUsers(selectedValues);
  };
  const fetchAllUsers = async () => {
    try {
      const redirectCallback = () => navigate('/');
      const usersData = await UserService.AllDiaryUsers(redirectCallback);
      setUserList(usersData);
      const user = await UserService.fetchUsersByID(redirectCallback);
      if (user[0].AllowUser) {
        const matchedDepots = usersData
          .filter(loc => user[0].AllowUser.includes(loc.UserID))
          .map(loc => (loc.UserID));

        setSelectedUsers(matchedDepots);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  // this function will load the modules assigned to a user. Off course for admin it will load all modules
  const fetchModules = async () => {
    try {
      const modules = await ModuleService.GetAllModules(() => navigate('/'), "en");
      updateSidebarModules(modules);
    } catch (error) {
      setErrorMessage('Failed to fetch modules. Please try again.');
      setIsLoading(false);
    }
  };


  // this function will fired when theme is changed
  const handleThemeChange = (e) => {
    const selectedTheme = e.target.value;
    if (selectedTheme !== theme) {
      toggleTheme();
    }
  };
  const getImageSrc = (action) => {

    if (ModuleID === "2") {
      return action === "add"
        ? "assets/img/resources/customer-add.png"
        : "assets/img/resources/customer-delete.png";
    } else if (ModuleID === "3") {
      return action === "add"
        ? "assets/img/resources/assets-add.png"
        : "assets/img/resources/assets-delete.png";
    }
    else if (ModuleID === "15") {
      return action === "add"
        ? "assets/img/resources/contacts-add.png"
        : "assets/img/resources/contacts-delete.png";
    }
    else if (ModuleID === "5") {
      return action === "add"
        ? "assets/img/resources/suppliers-add.png"
        : "assets/img/resources/suppliers-delete.png";
    }

    else if (ModuleID === "4") {
      return action === "add"
        ? "assets/img/resources/product-add.png"
        : "assets/img/resources/product-delete.png";
    }
    else if (ModuleID === "8") {
      return action === "add"
        ? "assets/img/resources/purchase-add.png"
        : "assets/img/resources/purchase-delete.png";
    }
    else if (ModuleID === "10") {
      return action === "add"
        ? "assets/img/resources/jobs-add.png"
        : "assets/img/resources/jobs-delete.png";
    }
    else if (ModuleID === "7") {
      return action === "add"
        ? "assets/img/resources/SOAdd.png"
        : "assets/img/resources/SODelete.png";
    }
    else if (ModuleID === "9") {
      return action === "add"
        ? "assets/img/resources/AgreementAdd.png"
        : "assets/img/resources/AgreementDelete.png";
    }
    else if (ModuleID === "6") {
      return action === "add"
        ? "assets/img/resources/QuoteAdd.png"
        : "assets/img/resources/QuoteDelete.png";
    }

    else if (ModuleID === "17") { //lead
      return action === "add"
        ? "assets/img/resources/Lead-add.png"
        : "assets/img/resources/Lead-delete.png";
    }
    else if (ModuleID === "18") { //opportunity
      return action === "add"
        ? "assets/img/resources/opportunity-add.png"
        : "assets/img/resources/opportunity-delete.png";
    }



    else {
      return action === "add"
        ? "assets/img/resources/sales-add.png"
        : "assets/img/resources/sales-delete.png";
    }
  }

  const fetchUsers = async () => {
    try {
      const redirectCallback = () => navigate('/');

      const user = await UserService.fetchUsersByID(redirectCallback);

      setFormData({
        Email: user[0].Email || '', DisplayName: user[0].DisplayName || '', UserPassword: user[0].UserPassword, ConfirmPassword: user[0].UserPassword,
        RoleID: user[0].RoleID || "0", TeamID: user[0].TeamID || "1", RateMethod: user[0].RateMethod || '1',
        ExchangePassword: user.ExchangePassword || '', Rate: user.Rate || '0.00', Cost: user.Cost || '0.00',
        AdditionalRate: user[0].AdditionalRate || '0.00', AdditionalCost: user[0].AdditionalCost || '0.00',
        WeekendRate: user[0].WeekendRate || '0.00', WeekendCost: user[0].WeekendCost || '0.00',
        UserName: user[0].UserName, RoleName: user[0].RoleName, TeamName: user[0].vc_Name,
        CompanyName: user[0].CompanyName, UserID: user[0].UserID, ProfilePic: user[0].ProfilePic,
        EmailFooter: user[0].EmailFooter,
        EmailAppPassword: user[0].EmailAppPassword,
        AllowUser: user[0].AllowUser

      });
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };
  const handleFieldChange = (event) => {
    handleChange(event, formData, setFormData);
  };
  const handleCloseModal = () => {
    setIsProfileModalOpen(false);
  };

  const handleFormSubmit = async (event) => {

    event.preventDefault();
    const UserID = localStorage.getItem("UserID");
    formData.UserID = UserID;
    const redirectCallback = () => {
      navigate('/'); // Redirect to the login page
    };
    const formDataWithDepots = {
      formData: formData,
      DepotList: selectedLocations,
      UserList: selectedUsers,

    };
    debugger;
    const postData = await handleUserSubmit(event, formData, setFormData, setErrors, selectedUsers);
    await fetchUsers();
    if (postData.message === "User added successfully") {
      localStorage.setItem('EmailFooter', formData.EmailFooter);
      Swal.fire(
        'success',
        "Data saved successfully",
        'success'
      );
    }
  };
  const handleStart = (e, ui) => {
    e.stopPropagation();
  }
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFormData(prevState => ({
      ...prevState,
      File: file,
      ProfilePic: file ? file.name : ''
    }));
  };
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };
  const handleRoleChange = async (role) => {

    setSelectedRole(role);
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to switch company!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Switch!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const userDetail = await UserService.UserDetailByEmail(localStorage.getItem('Email'), role);

          const formData = { UserName: localStorage.getItem('Email'), Password: userDetail[0].UserPassword, ClientID: role };


          const response = await handleSubmit(null, formData, "", setErrors, setErrorMessage);
          if (response.data.multipleCompanies === false) {

            localStorage.setItem('token', response.data.companies[0].token); // Access token
            localStorage.setItem('refreshToken', response.data.companies[0].refreshToken); // Refresh token
            localStorage.setItem('CompanyID', response.data.companies[0].HostCompanyID);
            localStorage.setItem('RoleID', response.data.companies[0].RolesID);
            localStorage.setItem('UserID', response.data.companies[0].UserID);
            localStorage.setItem('DisplayName', response.data.companies[0].DisplayName);
            localStorage.setItem('Email', response.data.companies[0].Email);
            localStorage.setItem('CompanyName', response.data.companies[0].CompanyName);
            localStorage.setItem('Address1', response.data.companies[0].Address1);
            localStorage.setItem('ContractPrefix', response.data.companies[0].ContractPrefix);
            localStorage.setItem('AllowedUsers', response.data.companies[0].AllowedUsers);
            const ModuleList = await ModuleService.GetAllModules(redirectCallback, "en");
            localStorage.setItem('ModuleList', JSON.stringify(ModuleList));
            const FormList = await FormService.GetAllForms(redirectCallback);
            localStorage.setItem('FormList', JSON.stringify(FormList));
            const clientLanguage = await ClientLanguages.GetClientLanguage(redirectCallback, response.data.companies[0].HostCompanyID);
            localStorage.setItem('ClientLanguages', JSON.stringify(clientLanguage));
            const HelpLink = await HelpLinkService.GetAllHelpLinks(redirectCallback);
            if (HelpLink && HelpLink[0]) {
              localStorage.setItem('HelpLink', HelpLink[0].HelpLink);
            }
            localStorage.setItem('IsAdminLogin', "0");
            localStorage.setItem('MultipleCompanies', "1");
            fetchModules();
            navigate('/Dashboard');
          }
        } catch (error) {
          console.error('Error deleting client:', error);
        }
      }
    });
    // You can store the role in localStorage or update state accordingly


  };
  const handleEditorChange = (content) => {
    setFormData({
      ...formData,
      EmailFooter: content
    });
  };
  const quillModules = {
    toolbar: [
      [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
      [{ size: [] }],
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' },
      { 'indent': '-1' }, { 'indent': '+1' }],
      ['link', 'image'],  // 👈 make sure 'image' is here
      ['clean']
    ]
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = "923339652022"; // Your company or support number
    const message = "Hello! I need help."; // Default message

    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodedMessage}&type=phone_number&app_absent=0`;

    window.open(whatsappURL, "_blank");
  };
  // this is the main html content (JSX) that are displayed in the browswer. It creates the header of the site. 
  return (
    <nav class="navbar navbar-expand fixed-top top-menu">
      <ul class="main-links">
        <li style={{ display: showAddButton }} className='hide-on-mobile'>
          <Link onClick={localStorage.getItem('LicenseExpired') == "0" ? () => handleAddTask() : undefined}>
            <img src={getImageSrc("add")} className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Add</strong>
          </Link>
        </li>
        <li style={{ display: showDeleteButton }} className='hide-on-mobile'>
          <Link onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => handleDeleteItem(event) : undefined}>
            <img src={getImageSrc("delete")} className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Delete icon" />
            <strong style={{ fontSize: "10px" }}>Delete</strong>
          </Link>
        </li>
        {(assignedModules.has(MODULE_IDS.Jobs) &&
          <li style={{ display: showServiceJob }} className='hide-on-mobile'>
            <Link
              onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
                if (isDisabled) {
                  event.preventDefault();
                  return;
                }
                handleServiceJob(event);
              } : undefined}
              className={`top-link ${isDisabled || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}
              style={{
                pointerEvents: isDisabled ? 'none' : 'auto',
                opacity: isDisabled ? 0.6 : 1,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
              }}
            >
              <img src="assets/img/resources/service.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
              <strong className="top-text" style={{ fontSize: "10px" }}>
                {"Service Job".split(" ").map((word, i) => (
                  <span key={i} className="top-word">
                    {word}
                  </span>
                ))}
              </strong>
            </Link>


          </li>
        )}

        <li style={{ display: showRenewButton }}>
          <Link
            onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
              if (isDisabled) {
                event.preventDefault();
                return;
              }
              handleRenewAgreement(event);
            } : undefined}
            className={isDisabled ? 'disabled' : ''}
            style={{
              pointerEvents: isDisabled ? 'none' : 'auto',
              opacity: isDisabled ? 0.6 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            <img src="assets/img/resources/AgreementRenew.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Renew</strong>
          </Link>
        </li>
        {(assignedModules.has(MODULE_IDS.SalesOrders) &&
          <li style={{ display: showSaleOrder }}>
            <Link
              onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
                if (isDisabled) {
                  event.preventDefault();
                  return;
                }
                handleSaleOrder(event);
              } : undefined}
              className={`top-link ${isDisabled || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}
              style={{
                pointerEvents: isDisabled ? 'none' : 'auto',
                opacity: isDisabled ? 0.6 : 1,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
              }}
            >
              <img src="assets/img/resources/saleadd.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />

              <strong className="top-text" style={{ fontSize: "10px" }}>
                {"Sales Order".split(" ").map((word, i) => (
                  <span key={i} className="top-word">
                    {word}
                  </span>
                ))}
              </strong>
            </Link>

          </li>
        )}
        {(assignedModules.has(MODULE_IDS.Invoices) &&
          <li style={{ display: showInvoice }}>
            <Link
              onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
                if (isDisabled) {
                  event.preventDefault();
                  return;
                }
                handleInvoice(event);
              } : undefined}
              className={isDisabled ? 'disabled' : ''}
              style={{
                pointerEvents: isDisabled ? 'none' : 'auto',
                opacity: isDisabled ? 0.6 : 1,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
              }}
            >
              <img src="assets/img/resources/saleadd.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
              <strong style={{ fontSize: "10px" }}>Invoice</strong>
            </Link>
          </li>
        )}

        <li style={{ display: showShortFallParts }}>
          <Link onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => handleShortFallParts(event) : undefined}>
            <img src="assets/img/resources/Shortfalls.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Shorfalls</strong>
          </Link>
        </li>
        <li style={{ display: showPurchaseOnOrder }}>
          <Link
            onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
              if (isDisabled) {
                event.preventDefault();
                return;
              }
              handlePurchaseOnOrder(event);
            } : undefined}
            className={isDisabled ? 'disabled' : ''}
            style={{
              pointerEvents: isDisabled ? 'none' : 'auto',
              opacity: isDisabled ? 0.6 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            <img src="assets/img/resources/order.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>On Order</strong>
          </Link>


        </li>
        <li style={{ display: showPurchaseDelivery }}>
          <Link
            onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
              if (isDisabled) {
                event.preventDefault();
                return;
              }
              handlePurchaseOnOrderDelivery(event);
            } : undefined}
            className={isDisabled ? 'disabled' : ''}
            style={{
              pointerEvents: isDisabled ? 'none' : 'auto',
              opacity: isDisabled ? 0.6 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            <img src="assets/img/resources/deliver.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Deliver</strong>
          </Link>
        </li>
        <li style={{ display: showShipSaleOrder }}>
          <Link
            onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
              if (isDisabled) {
                event.preventDefault();
                return;
              }
              handleShipSaleOrder(event);
            } : undefined}
            className={isDisabled ? 'disabled' : ''}
            style={{
              pointerEvents: isDisabled ? 'none' : 'auto',
              opacity: isDisabled ? 0.6 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            <img src="assets/img/resources/saleadd-allocate.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Allocate</strong>
          </Link>
        </li>
        <li style={{ display: showUnAllocate }}>
          <Link
            onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
              if (isDisabled) {
                event.preventDefault();
                return;
              }
              handleUnAllocate(event);
            } : undefined}
            className={isDisabled ? 'disabled' : ''}
            style={{
              pointerEvents: isDisabled ? 'none' : 'auto',
              opacity: isDisabled ? 0.6 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            <img src="assets/img/resources/SODeAllocate.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>UnAllocate</strong>
          </Link>
        </li>
        <li style={{ display: showClientButton }}>
          <Link onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => handleCreateClientClick(event) : undefined}>
            <img src="assets/img/resources/sales-add.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Add</strong>
          </Link>
        </li>
        <li style={{ display: showShippment }}>

          <Link
            onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
              if (isDisabled) {
                event.preventDefault();
                return;
              }
              handleShippment(event);
            } : undefined}
            className={isDisabled ? 'disabled' : ''}
            style={{
              pointerEvents: isDisabled ? 'none' : 'auto',
              opacity: isDisabled ? 0.6 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            <img src="assets/img/resources/SOShip.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>{handleShippmentTitle}</strong>
          </Link>
        </li>
        {(assignedModules.has(MODULE_IDS.Opportunities) &&
          <li style={{ display: showCreateOppotunity }}>
            <Link
              onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
                if (isDisabled) {
                  event.preventDefault();
                  return;
                }
                handleCreateOppotunity(event);
              } : undefined}
              className={isDisabled ? 'disabled' : ''}
              style={{
                pointerEvents: isDisabled ? 'none' : 'auto',
                opacity: isDisabled ? 0.6 : 1,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
              }}
            >
              <img src="assets/img/resources/customer-add.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
              <strong style={{ fontSize: "10px" }}>Opportunity</strong>
            </Link>


          </li>
        )}
        <li style={{ display: showCreateCustomer }}>
          <Link
            onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
              if (isDisabled) {
                event.preventDefault();
                return;
              }
              handleCreateCustomer(event);
            } : undefined}
            className={isDisabled ? 'disabled' : ''}
            style={{
              pointerEvents: isDisabled ? 'none' : 'auto',
              opacity: isDisabled ? 0.6 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            <img src="assets/img/resources/customer-add.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Customer</strong>
          </Link>
        </li>
        <li style={{ display: showLeadSchedular }}>
          <Link onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => handleLeadSchedular(event) : undefined}>
            <img src="assets/img/resources/Diaries.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Appointments</strong>
          </Link>
        </li>
        <li style={{ display: showSynchronize }}>

          <Link onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => { handleSynchronize(event); } : undefined}>
            <img src="assets/img/resources/weblink.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Sync</strong>
          </Link>



        </li>


        <li className="nav-item dropdown"
          style={{
            display:
              showWriteOffButton !== "none" || showReinstateButton !== "none"
                ? "block"
                : "none",
          }}
        >
          <a
            className="dropdown-toggle"
            href="#"
            id="assignGroupDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            title={titleBar}
            style={{ cursor: "pointer" }}

          >
            <img src="assets/img/resources/Shortfalls.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="" />
            <strong className="top-text" style={{ fontSize: "10px" }}>
              {("Write Off")
                .split(" ")
                .map((word, index) => (
                  <span key={index} className="top-word">
                    {word}
                  </span>
                ))}
            </strong>
          </a>

          <div className="dropdown-menu" aria-labelledby="assignGroupDropdown">
            {showWriteOffButton !== "none" && (
              <a className="dropdown-item" onClick={(e) => handleWriteOff(e)}>
                <img
                  src="assets/img/resources/Shortfalls.png"
                  className="dropdown-icon"
                  alt=""
                />
                Write Off
              </a>
            )}

            {showReinstateButton !== "none" && (
              <a className="dropdown-item" onClick={(e) => handleReinstate(e)}>
                <img
                  src="assets/img/resources/Shortfalls.png"
                  className="dropdown-icon"
                  alt=""
                />
                Reinstate
              </a>
            )}
          </div>
        </li>





        <li style={{ display: showBatchButton }}>
          <Link
            onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
              if (isDisabled) {
                event.preventDefault();
                return;
              }
              handleBatchManagement(event);
            } : undefined}
            className={isDisabled ? 'disabled' : ''}
            style={{
              pointerEvents: isDisabled ? 'none' : 'auto',
              opacity: isDisabled ? 0.6 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            <img src="assets/img/resources/batch.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Batch No.</strong>
          </Link>



        </li>
        <li style={{ display: showExportButton }}>
          <Link
            onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
              handleExportExcel(event);
            } : undefined}


          >
            <img src="assets/img/resources/export.JPG" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Export</strong>
          </Link>



        </li>
        <li style={{ display: showSerialButton }}>
          <Link
            onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
              if (isDisabled) {
                event.preventDefault();
                return;
              }
              handleSerialTracking(event);
            } : undefined}
            className={isDisabled ? 'disabled' : ''}
            style={{
              pointerEvents: isDisabled ? 'none' : 'auto',
              opacity: isDisabled ? 0.6 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            <img src="assets/img/resources/serial.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Serial No.</strong>
          </Link>
        </li>

        <li style={{ display: showEmailButton }}>
          <Link
            onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
              if (isDisabled && IsAttachment === "1") {
                event.preventDefault();
                return;
              }
              handleSendEmail(event);
            } : undefined}
            className={isDisabled && IsAttachment === "1" ? 'disabled' : ''}
            style={{
              pointerEvents: isDisabled && IsAttachment ? 'none' : 'auto',
              opacity: isDisabled && IsAttachment ? 0.6 : 1,
              cursor: isDisabled && IsAttachment ? 'not-allowed' : 'pointer',
            }}

          >
            <img src="assets/img/resources/email-icon.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Email</strong>
          </Link>



        </li>
        {(assignedModules.has(MODULE_IDS.Parts) &&
          <li style={{ display: showPartMovment }}>
            <Link onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
              handlePartMovment(event);
            } : undefined} className={`top-link`}>
              <img src="assets/img/resources/saleadd.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />

              <strong className="top-text" style={{ fontSize: "10px" }} title='Stock Movement'>
                {"Stock Mov...".split(" ").map((word, i) => (
                  <span key={i} className="top-word">
                    {word}
                  </span>
                ))}
              </strong>
            </Link>
          </li>


        )}

        {(assignedModules.has(MODULE_IDS.Parts) &&
          <li style={{ display: showPartDiscountButton }}>
            <Link onClick={localStorage.getItem('LicenseExpired') == "0" ? (event) => {
              handlePartDiscount(event);
            } : undefined} className={`top-link`}>
              <img src="assets/img/resources/cust_price-list.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />

              <strong className="top-text" style={{ fontSize: "10px" }} title='Price List'>
                {"Price List".split(" ").map((word, i) => (
                  <span key={i} className="top-word">
                    {word}
                  </span>
                ))}
              </strong>
            </Link>
          </li>


        )}




        <li
          className="nav-item dropdown"
          style={{
            display:
              showSendEmailing !== "none" ||
                showEmailingList !== "none" ||
                showResetEmailingList !== "none"
                ? "block"
                : "none",
          }}
        >
          <a
            className="dropdown-toggle"
            href="#"
            id="emailGroupDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            style={{ cursor: "pointer" }}
          >
            <img src="assets/img/resources/saveEmail.jpeg" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="" />
            <strong style={{ fontSize: "10px" }}>Mail List</strong>
          </a>

          <div className="dropdown-menu" aria-labelledby="emailGroupDropdown">
            {showSendEmailing !== "none" && (
              <a className="dropdown-item" onClick={(e) => handleEmailing(e)}>
                <img
                  src="assets/img/resources/saveEmail.jpeg"
                  className="dropdown-icon"
                  alt=""
                />
                Save
              </a>
            )}

            {showEmailingList !== "none" && (
              <a className="dropdown-item" onClick={(e) => handleEmailingList(e)}>
                <img
                  src="assets/img/resources/mail-list-icon.jpg"
                  className="dropdown-icon"
                  alt=""
                />
                Load
              </a>
            )}

            {showResetEmailingList !== "none" && (
              <a className="dropdown-item" onClick={(e) => handleReset(e)}>
                <img
                  src="assets/img/resources/reset.jpeg"
                  className="dropdown-icon"
                  alt=""
                />
                Reset
              </a>
            )}
          </div>
        </li>
        <li
          className="nav-item dropdown"
          style={{
            display:
              showAssignUser !== "none" || showUnAssignUser !== "none"
                ? "block"
                : "none",
          }}
        >
          <a
            className="dropdown-toggle"
            href="#"
            id="assignGroupDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            title={titleBar}
            style={{ cursor: "pointer" }}

          >
            <img src="assets/img/resources/assign.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="" />
            <strong className="top-text" style={{ fontSize: "10px" }}>
              {(assignmentTitle || "Assignment")
                .split(" ")
                .map((word, index) => (
                  <span key={index} className="top-word">
                    {word}
                  </span>
                ))}
            </strong>
          </a>

          <div className="dropdown-menu" aria-labelledby="assignGroupDropdown">
            {showAssignUser !== "none" && (
              <a className="dropdown-item" onClick={(e) => handleAssignToUser(e)}>
                <img
                  src="assets/img/resources/assign.png"
                  className="dropdown-icon"
                  alt=""
                />
                Assign
              </a>
            )}

            {showUnAssignUser !== "none" && (
              <a className="dropdown-item" onClick={(e) => handleUnAssignToUser(e)}>
                <img
                  src="assets/img/resources/unassign.jpeg"
                  className="dropdown-icon"
                  alt=""
                />
                UnAssign
              </a>
            )}
          </div>
        </li>


        <li style={{ display: showPrintUser }} className='hide-on-mobile'>
          <Link
            onClick={(event) => {

              handlePrintUser(event);
            }}

          >
            <img src="assets/img/resources/print.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
            <strong style={{ fontSize: "10px" }}>Print</strong>
          </Link>
        </li>
        <li className="nav-item dropdown"
          style={{
            display:
              showAssignUser !== "none" || showUnAssignUser !== "none"
                ? "block"
                : "none",
          }}
        >
          <a
            className="dropdown-toggle"
            href="#"
            id="assignGroupDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            title={titleBar}
            style={{ cursor: "pointer" }}

          >
            <img src="assets/img/resources/saveEmail.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="" />
            <strong className="top-text" style={{ fontSize: "10px" }}>
              {("Inbox Emails")
                .split(" ")
                .map((word, index) => (
                  <span key={index} className="top-word">
                    {word}
                  </span>
                ))}
            </strong>
          </a>

          <div className="dropdown-menu" aria-labelledby="assignGroupDropdown">
            {showInboxEmail !== "none" && (
              <a className="dropdown-item" onClick={(e) => handleInboxEmail(e)}>
                <img
                  src="assets/img/resources/inbox-emails.png"
                  className="dropdown-icon"
                  alt=""
                />
                Inbox
              </a>
            )}

            {showSyncInboxEmail !== "none" && (
              <a className="dropdown-item" onClick={(e) => handleSyncInboxEmail(e)}>
                <img
                  src="assets/img/resources/syncEmail.png"
                  className="dropdown-icon"
                  alt=""
                />
                Sync
              </a>
            )}
          </div>
        </li>
        <li style={{ display: showInvoiceButton }}>
          <Link
            onClick={(event) => {
              if (isDisabled) {
                event.preventDefault();
                return;
              }
              handleInvoiceCreate(event);
            }}
            className={`top-link ${isDisabled ? 'disabled' : ''}`}
            style={{
              pointerEvents: isDisabled ? 'none' : 'auto',
              opacity: isDisabled ? 0.6 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            <img
              src="assets/img/resources/saveEmail.jpeg"
              className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}
              alt="Inbox Email"
            />
            <strong className="top-text" style={{ fontSize: "10px" }}>
              {"Invoice".split(" ").map((word, i) => (
                <span key={i} className="top-word">
                  {word}
                </span>
              ))}
            </strong>
          </Link>
        </li>

      </ul>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        {parseInt(localStorage.getItem('RoleID')) > 0 && ModuleName === "Dashboard" && (
          <ul class="navbar-nav center-nav ml-auto hide-on-mobile">
            <li>
              <h5 class="prefixBackground"> {localStorage.getItem('CompanyName')}</h5>
            </li>
          </ul>
        )}

        <ul class="main-links navbar-nav right-nav ml-auto right-links">
          <li className="nav-item hide-on-mobile">
            <Link onClick={() => handleReportsClick()} className={RecordID?.length > 1 ? 'disabled' : ''}>
              <img src="assets/img/resources/report.png" className={`top-icon ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} alt="Add icon" />
              <strong style={{ fontSize: "10px" }}>Reports</strong>
            </Link>
          </li>
          <li className="nav-item hide-on-mobile">
            <HelpSite FormName={HelpFormName} Module={HelpModule} />
          </li>

          <li className="nav-item hide-on-mobile">
            <select id="ddlTheme" style={{ marginTop: "8px", height: "34px" }} className="form-control" value={theme} onChange={handleThemeChange}>
              <option value="light">Light Theme</option>
              <option value="dark">Dark Theme</option>
            </select>
          </li>

          <li class="nav-item dropdown profile-nav-item">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div class="menu-profile">
                {formData.ProfilePic ? (
                  <img
                    src={`${BASE_URL}/uploads/${CompanyID}/Setup/Profile/${formData.ProfilePic}`}
                    class="rounded-circle" alt="Profile Image"
                  />
                ) :
                  (
                    <img src="assets/img/profile.png" alt="Profile Image" class="rounded-circle" />
                  )}
                <span class="name">{formData.DisplayName}</span>
                {(userNotification[0].TotalTasks > 0 || userNotification[0].TotalAppointments > 0) && (
                  <span
                    style={{
                      position: 'absolute',
                      top: '0px',
                      right: '0px',
                      backgroundColor: 'red',
                      color: 'white',
                      borderRadius: '50%',
                      padding: '2px 6px',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      lineHeight: '1',
                    }}
                  >
                    {userNotification[0].TotalTasks + userNotification[0].TotalAppointments}
                  </span>
                )}
              </div>
            </a>

            <div class="dropdown-menu">
              <a class="dropdown-item" href="#" onClick={() => handleProfileClick()}>
                Profile
              </a>
              <a class="dropdown-item" href="#" onClick={handleMfaSetupClick}>
                Multifactor Authentication
              </a>
              <a class="dropdown-item" href="#" onClick={handleResetMfaClick}>
                Reset MF Authentication
              </a>
              {IsAdminLogin === "1" && (
                <a class="dropdown-item" href="#" onClick={() => handleLoginClick("SAM3Administrator", "R3mbrandt14?")}>
                  Returns
                </a>
              )}
              {multipleCompanies === "1" && (
                <>

                  <div className="dropdown-item" onClick={(e) => e.stopPropagation()}>

                    <select
                      id="roleSelect"

                      style={{ padding: "0px 0px", border: "none", marginLeft: "-3px" }}
                      value={selectedRole}
                      onChange={(e) => handleRoleChange(e.target.value)}
                    >
                      <option value="0"> Switch Company</option>
                      {companies && companies.length > 0 ? (
                        companies.map((company) => (
                          <option key={company.HostCompanyID} value={company.HostCompanyID}>
                            {company.CompanyName}
                          </option>
                        ))
                      ) : (
                        <option disabled>No companies available</option>
                      )}
                    </select>
                  </div>
                </>
              )}
              <Link class="dropdown-item" to="/">

                Logout
              </Link>
            </div>
          </li>
        </ul>
        {isProfileModalOpen && (
          <form onSubmit={handleFormSubmit}>
            <div className="modal fade userProfileModal show d-block" id="userProfileModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="userProfileModalLabel" aria-hidden="true">
              <div className="modal-dialog modal-xl">
                <Draggable handle=".modal-header" onStart={handleStart}
                  cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                  bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                  <div className="modal-content">
                    <div className={`modal-header ${accordTheme}`}>
                      <h5 className="modal-title" id="largeModalLabel">Edit Profile</h5>
                      <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={handleCloseModal}>
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                        <label htmlFor="Email" className="col-sm-2 col-form-label">Email</label>
                        <div className="col-sm-4">
                          <input type="text" className='form-control' name="Email" value={formData.Email} onChange={handleFieldChange} disabled="true" />
                          {errors.Email && <div style={{ color: 'red' }}>{errors.Email}</div>}
                        </div>

                        <label htmlFor="CompanyName" className="col-sm-2 col-form-label">Company Name</label>
                        <div className="col-sm-4">
                          <input type="text" className='form-control' name="CompanyName" value={formData.CompanyName} onChange={handleFieldChange} disabled="true" />
                          {errors.CompanyName && <div style={{ color: 'red' }}>{errors.CompanyName}</div>}
                        </div>

                      </div>
                      <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                        <label htmlFor="UserName" className="col-sm-2 col-form-label">User Name</label>
                        <div className="col-sm-4">
                          <input type="text" className='form-control' name="UserName" value={formData.UserName} onChange={(e) => setFormData(prev => ({ ...prev, UserName: e.target.value.toLowerCase() }))} />
                          {errors.UserName && <div style={{ color: 'red' }}>{errors.UserName}</div>}
                        </div>
                        <label htmlFor="RoleID" className="col-sm-2 col-form-label">{t('role')}</label>
                        <div className="col-sm-4">

                          <input type="text" className='form-control' name="RoleName" value={formData.RoleName} onChange={handleFieldChange} disabled="true" />
                          {errors.RoleName && <div style={{ color: 'red' }}>{errors.RoleName}</div>}

                        </div>
                      </div>


                      <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                        <label htmlFor="DisplayName" className="col-sm-2 col-form-label">{t('displayName')}</label>
                        <div className="col-sm-4">
                          <input type="text" className='form-control' name="DisplayName" value={formData.DisplayName} onChange={handleFieldChange} />
                          {errors.DisplayName && <div style={{ color: 'red' }}>{errors.DisplayName}</div>}
                        </div>
                        <label htmlFor="TeamID" className="col-sm-2 col-form-label">{t('team')}</label>
                        <div className="col-sm-4">
                          <input type="text" className='form-control' name="TeamName" value={formData.TeamName} onChange={handleFieldChange} disabled="true" />
                          {errors.TeamName && <div style={{ color: 'red' }}>{errors.TeamName}</div>}
                        </div>
                      </div>
                      <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                        <label htmlFor="Path" className="col-sm-2 col-form-label">Upload Picture</label>
                        <div className="col-sm-4">
                          <input type="file" className="form-control file-control" name="File" onChange={handleFileChange} />
                          {errors.Path && <div style={{ color: 'red' }}>{errors.Path}</div>}


                        </div>
                        <label htmlFor="Path" className="col-sm-2 col-form-label">Allow Diaries</label>
                        <div className="col-sm-4">
                          <MultiSelectDropdown
                            options={userOptions}
                            selectedOptions={selectedUsers}
                            onChange={handleUserNameChange} // Pass handler here
                          />
                        </div>
                      </div>
                      <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                        <label htmlFor="Path" className="col-sm-2 col-form-label">App Password</label>
                        <div className="col-sm-4">
                          <input type="text" className='form-control' name="EmailAppPassword" value={formData.EmailAppPassword} onChange={handleFieldChange} />



                        </div>

                      </div>
                      <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                        <label htmlFor="Path" className="col-sm-2 col-form-label">Email Footer</label>
                        <div className="col-sm-10">
                          <SunTextEditor
                            value={formData.EmailFooter}
                            onChange={(cleanHtml) => setFormData({ ...formData, EmailFooter: cleanHtml })}
                            height={200}
                          />

                          {errors.EmailFooter && <div style={{ color: 'red' }}>{errors.EmailFooter}</div>}


                        </div>
                      </div>

                    </div>
                    <div className="modal-footer">
                      <button type="submit" className="btn btn-primary">
                        <i className="icofont-save" aria-hidden="true"> Update</i>
                      </button>
                      <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close" onClick={handleCloseModal}>
                        <i className="icofont-close" aria-hidden="true"> Close</i>
                      </button>
                    </div>
                  </div>
                </Draggable>
              </div>
            </div>
          </form>
        )}


        {isModalOpen && (
          <ReportView
            show={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            ModuleID={ModuleID}
            ID={RecordID ?? 0}
          />
        )}
        {isMfaModalOpen && (
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-md" role="document">
              <div className="modal-content">
                <div className={`modal-header ${accordTheme}`}>
                  <h5 className="modal-title">Setup Authenticator App</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsMfaModalOpen(false)}
                  ></button>
                </div>
                <div className="modal-body text-center">
                  {!qrCode ? (
                    <>
                      <p>
                        Click below to generate a QR code and scan it using Google Authenticator or Microsoft Authenticator.
                      </p>
                      <button
                        className="btn btn-primary mt-3"
                        onClick={async () => {
                          try {
                            const email = localStorage.getItem("UserName") || "";
                            const res = await fetch(`${BASE_URL}/Auth/generate-auth-secret`, {
                              method: "POST",
                              headers: { "Content-Type": "application/json" },
                              body: JSON.stringify({ email }),
                            });
                            const data = await res.json();

                            if (data.qr) {
                              setQrCode(data.qr);
                              setSecretKey(data.secret);
                              setMessage(
                                data.message ||
                                "Scan this QR with Google or Microsoft Authenticator."
                              );
                            } else {
                              setMessage("Failed to generate QR code.");
                            }
                          } catch (err) {
                            console.error("Error generating secret:", err);
                            setMessage("Error connecting to server.");
                          }
                        }}
                      >
                        Generate QR Code
                      </button>
                    </>
                  ) : (
                    <>
                      <div className="mt-3">
                        <img src={qrCode} alt="Authenticator QR" style={{ width: "200px" }} />
                      </div>
                      <p className="mt-2">{message}</p>
                      <p>
                        <b>Secret (for backup):</b> {secretKey}
                      </p>

                      <hr />
                      <p>Enter the 6-digit verification code from your Authenticator app:</p>
                      <input
                        type="text"
                        maxLength="6"
                        value={mfaCode}
                        onChange={(e) => setMfaCode(e.target.value)}
                        className="form-control text-center"
                        style={{ width: "150px", margin: "0 auto" }}
                      />
                      <button
                        className="btn btn-success mt-3"
                        onClick={async () => {
                          try {
                            const email = localStorage.getItem("UserName") || "";
                            const res = await fetch(`${BASE_URL}/Auth/verify-auth-code`, {
                              method: "POST",
                              headers: { "Content-Type": "application/json" },
                              body: JSON.stringify({ email, token: mfaCode }),
                            });
                            const data = await res.json();

                            if (data.success) {
                              Swal.fire("Success", "Multifactor Authentication setup completed!", "success");
                              setIsMfaModalOpen(false);
                              setQrCode(null);
                              setSecretKey("");
                              setMfaCode("");
                            } else {
                              Swal.fire("Invalid Code", "The verification code is incorrect.", "error");
                            }
                          } catch (error) {
                            Swal.fire("Error", "Verification failed. Try again.", "error");
                          }
                        }}
                      >
                        Verify & Enable
                      </button>
                      <button style={{ "marginLeft": "5px" }} className="btn btn-warning mt-3" onClick={() => setIsMfaModalOpen(false)}>
                        Cancel
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
      <div
        onClick={handleWhatsAppClick}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          backgroundColor: '#ffffff',
          borderRadius: '50%',
          width: '60px',
          height: '60px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
          zIndex: 9999,
          display: 'none'
        }}
        title="Chat on WhatsApp"
      >
        <img
          src="assets/img/resources/whatsapp-icon.jpg"
          alt="WhatsApp"
          style={{ width: '35px', height: '35px' }}
        />
      </div>
    </nav>

  );
}

export default Common;